import React, { Component } from 'react';
import './BrochureGeneration.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import MenuType from '../enums/MenuType';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import ParameterErrors from '../errors/ParameterErrors';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import PhoneNumberValidation from '../validation/PhoneNumberValidation';
import EmailValidation from '../validation/EmailValidation';
import Dialog from './Dialog';
import Checkbox from './Checkbox';
import Handles from '../core/Handles';
import Spinner from './Spinner';
import AssetsManager from '../assets_management/AssetsManager';
import HashSource from '../core/HashSource';
import BrochuresManager from '../brochures/BrochuresManager';
import SessionManager from '../sessions/SessionManager';
import RunningMode from '../RunningMode';
import GoogleAnalytics from '../google/GoogleAnalytics';
import Tutorials from '../tutorials/Tutorials';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class BrochureGeneration extends Component {
	constructor(props){
		super(props);
		const {getSiteAndUnits, showBrochuresMenu, getSelectedFavourites, getConfiguration} = props;
		this._getConfiguration = getConfiguration;
		if(!getSiteAndUnits)throwNotProvided('getSiteAndUnits');
		this._getSiteAndUnits = getSiteAndUnits;
		this._getSelectedFavourites = getSelectedFavourites;
		this._showBrochuresMenu = showBrochuresMenu;
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._titleRef = React.createRef();
		this._firstNameRef = React.createRef();
		this._surnameRef = React.createRef();
		this._phoneNumberRef = React.createRef();
		this._checkboxOptInPhoneRef = React.createRef();
		this._checkboxOptInEmailRef = React.createRef();
		this._checkboxOptInTextRef = React.createRef();
		this._emailRef = React.createRef();
		this._privacyNoticeCheckboxRef = React.createRef();
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.load = this.load.bind(this);
		this._iMenuManager  = null;
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._currentDialog = null;
		this._agreedToPrivacyNotice= false;
		this._handleClickGenerate = this._handleClickGenerate.bind(this);
		this._startPdfDownload= this._startPdfDownload.bind(this)
		this._handleTitleChange = this._handleTitleChange.bind(this);
		this._handleFirstNameChange = this._handleFirstNameChange.bind(this);
		this._handleSurnameChange = this._handleSurnameChange.bind(this);
		this._handleEmailChange = this._handleEmailChange.bind(this);
		this._handlePhoneNumberChange = this._handlePhoneNumberChange.bind(this);
		this._handleClickShowPrivacyPolicy = this._handleClickShowPrivacyPolicy.bind(this);
		this._validateText = this._validateText.bind(this);
		this._validatePhoneNumber = this._validatePhoneNumber.bind(this);
		this._validateEmail=this._validateEmail.bind(this);
		this._getClassNameField = this._getClassNameField.bind(this);
		this._disposeCurrentDialog = this._disposeCurrentDialog.bind(this);
		this._showHasNoPlotsFavouritedDialog = this._showHasNoPlotsFavouritedDialog.bind(this);
		this._showYouMustAgreeToPrivacyNoticeDialog = this._showYouMustAgreeToPrivacyNoticeDialog.bind(this);
		this._getOptInOptions= this._getOptInOptions.bind(this);
		this._onClickBrochureGenerationResultDialog= this._onClickBrochureGenerationResultDialog.bind(this);
		this._handleCheckboxAgreedToPrivacyNoticeChanged= this._handleCheckboxAgreedToPrivacyNoticeChanged.bind(this);
		this._showResponseDialog = this._showResponseDialog.bind(this);
		this._setGenerating = this._setGenerating.bind(this);
		this.state = {generating:false, visible:false, titleValid:true, 
			emailValid:true, phoneNumberValid:true, firstNameValid:true,
			surnameValid:true, agreedToPrivacyNotice:false};
		this._spinnerHandles = new Handles();
	}
	load(props){
		const {plots }=props||{};
		this._plotsShownFor = plots;
		this.show();
	}
	show(){
		document.body.classList.add('showing-brochure-generation-menu');
		this.setState({visible:true});
		this._iMenuManager.showMe(this);
		this._clickedOffManager.register();
	}
	hide(){
		document.body.classList.remove('showing-brochure-generation-menu');
		setTimeout(Tutorials.dispatchUpdate, 0);
		this._plotsShownFor = null;
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
		this._disposeCurrentDialog();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.BROCHURE_GENERATION;
	}
	_disposeCurrentDialog(){
		if(this._currentDialog&&this._currentDialog.current)	
			this._currentDialog.current.dispose();
		this._currentDialog= null;
	}
	_showHasNoPlotsFavouritedDialog(){
		this._currentDialog = Dialog.create({
			title:'Error', 
			className:'brochure-generation-result-dialog error',
			message:'No plots favourited. Please click on the plots you like and click the favourite star :(',
			options:[{text:'OK', callback:this.hide}]}
		);
	}
	_showYouMustAgreeToPrivacyNoticeDialog(){
		this._currentDialog = Dialog.create({
			title:'Error', 
			className:'brochure-generation-result-dialog error',
			message:'You must agree to the privacy notice!',
			options:[{text:'OK'}]}
		);
	}
	_handleClickGenerate(){
		if(this.state.generating)return;
		if(!this._validateOnSubmission())
				return;
		const [site, units] = this._getSiteAndUnits();
		const selectedPlotsArray = this._getSelectedFavourites();
		const hasNoPlots = (!this._plotsShownFor||this._plotsShownFor.length<1)&&(selectedPlotsArray.length<1);
		if(hasNoPlots)
		{
			this._showHasNoPlotsFavouritedDialog();
			return;
		}
		if(!this._agreedToPrivacyNotice)
		{
			this._showYouMustAgreeToPrivacyNoticeDialog();
			return;
		}
		const spinnerHandle = this._spinnerHandles.take();
		try{
			const selectedPlots = (this._plotsShownFor?this._plotsShownFor:selectedPlotsArray);
			const selectedPlotsEnabled = selectedPlots.filter(selectedPlot=>selectedPlot?.houseType?.brochureEnabled!==false);
			const plotNumbers = selectedPlotsEnabled.map(selectedPlot=>selectedPlot.number);
			const singlePlotBrochure = this._plotsShownFor?true:false;
			const configuration = this._getConfiguration();
			const { siteName, siteSlug}= configuration;
			this._setGenerating(true);
			
			document.body.classList.add('has-generated-brochure');
			BrochuresManager.instance.generate({
				siteName,
				siteSlug,
				singlePlotBrochure,
				plotNumbers,
				title:this._title,
				firstName:this._firstName,
				surname:this._surname,
				email:this._email,
				phoneNumber:this._phoneNumber,
				optInOptions:this._getOptInOptions(),
				agreedToPrivacyNotice:this._agreedToPrivacyNotice,
				debug:RunningMode.isDevelopment
			}).then((jObjectResponse)=>{
				this._setGenerating(false);
				spinnerHandle.dispose();
				this._showResponseDialog(jObjectResponse);
			}).catch((err)=>{
				this._setGenerating(false);
				console.error(err);
				spinnerHandle.dispose();
			});
			GoogleAnalytics.logEvent('generatedBrochure', {plotNumbers});
		}
		catch{
			this._setGenerating(false);
			spinnerHandle.dispose();
		}
	}
	_setGenerating(value){
		this.setState({generating:value});
	}
	_showResponseDialog(jObjectResponse){
		this._disposeCurrentDialog();
		if(!jObjectResponse.error){
			this.hide();
			this._currentDialog = Dialog.create({
				title:'Success', 
				className:'brochure-generation-result-dialog',
				message:'You should receive an email shortly containing the brochure',
				onClickClose:this.hide,
				options:[{text:'OK', callback:this._showBrochuresMenu}]}
			);
			return;
		}
		console.error(jObjectResponse.error);
		this._currentDialog = Dialog.create({
			title:'Error', 
			className:'brochure-generation-result-dialog error',
			message:'An error occured while generating the brochure :(',
			options:[{text:'Retry', callback:this._handleClickGenerate}, {text:'OK', callback:this.hide}]}
		);
	}
	_getOptInOptions(){
		var strs = [];
		if(this._checkboxOptInEmailRef.current.checked)
			strs.push('email');
		if(this._checkboxOptInPhoneRef.current.checked)
			strs.push('phone');
		if(this._checkboxOptInTextRef.current.checked)
			strs.push('text');
		return strs.join(',');
	}
	_onClickBrochureGenerationResultDialog(){
		
	}
	_startPdfDownload(url){
		const link = document.createElement('a');
		link.href = url;
		link.target="_blank";
		link.download = 'brochure.pdf';
		link.click();
	}
	_handleTitleChange(e){
		this._title = e.target.value;
		this.setState({titleValid:this._validateText(this._title)});
	}
	_handleFirstNameChange(e){
		this._firstName = e.target.value;
		this.setState({firstNameValid:this._validateText(this._firstName)});
	}
	_handleSurnameChange(e){
		this._surname = e.target.value;
		this.setState({surnameValid:this._validateText(this._surname)});
	}
	_handlePhoneNumberChange(e){
		this._phoneNumber = e.target.value;
		this.setState({phoneNumberValid:this._validateText(this._phoneNumber)});
	}
	_handleEmailChange(e){
		this._email = e.target.value;
		this.setState({emailValid:this._validateText(this._email)});
	}
	_validateText(text, allowEmpty){
		if(allowEmpty===undefined)allowEmpty=true;
		return text!==undefined&&text!==null&&(allowEmpty||text.length>0);
	}
	_validatePhoneNumber(text, allowEmpty){
		let valid = this._validateText(text, allowEmpty);
		if(!valid)return false;
		if(text.length<1&&allowEmpty)return true;
		return PhoneNumberValidation.validateInternational(text);
	}
	_validateEmail(text, allowEmpty){
		let valid = this._validateText(text, allowEmpty);
		if(!valid)return false;
		if(text.length<1&&allowEmpty)return true;
		return EmailValidation.emailRFC5322(text);
	}
	_validateOnSubmission(){
		const titleValid = this._validateText(this._title, false);
		const firstNameValid= this._validateText(this._firstName, false);
		const surnameValid= this._validateText(this._surname, false);
		const emailValid= this._validateEmail(this._email, false);
		const phoneNumberValid= this._validatePhoneNumber(this._phoneNumber, false);
		this.setState({
			titleValid:titleValid,
			firstNameValid:firstNameValid,
			surnameValid:surnameValid,
			emailValid:emailValid,
			phoneNumberValid:phoneNumberValid
		});
		return titleValid&&firstNameValid&&surnameValid&&emailValid&&phoneNumberValid;
	}
	_getClassNameField(name, valid){
		return `${name} full-width field ${valid?"valid":"invalid"}`;
	}
	_handleClickShowPrivacyPolicy(){
		this._iMenuManager.showMenuByType(MenuType.PRIVACY_POLICY);
	}
	_handleCheckboxAgreedToPrivacyNoticeChanged(e){
		this._agreedToPrivacyNotice = e.checked
		this.setState({agreedToPrivacyNotice:this._agreedToPrivacyNotice});
	}
	render() {
		let className = "brochure-generation menu";
		if(this.state.visible)
			className+= " visible"
		const classNameIconButtonGenerate= 'submit '+(this.state.generating?"rotate":null);
		return (
			<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Enter your details"></SubMenuHeader>
				<div className="content">
					<div className="fields">
						<input type="text" disabled={this.state.generating} className={this._getClassNameField("title" , this.state.titleValid)} placeholder="Title" onChange={this._handleTitleChange} ref={this._titleRef}/>
						<input type="text" disabled={this.state.generating} className={this._getClassNameField("first-name" , this.state.firstNameValid)} placeholder="Forename" onChange={this._handleFirstNameChange}  ref={this._firstNameRef}/>
						<input type="text" disabled={this.state.generating} className={this._getClassNameField("surname" , this.state.surnameValid)} placeholder="Surname" onChange={this._handleSurnameChange}ref={this._surnameRef}/>
						<input type="text" disabled={this.state.generating} className={this._getClassNameField("phone-number" , this.state.phoneNumberValid)} placeholder="Phone number" onChange={this._handlePhoneNumberChange}ref={this._phoneNumberRef}/>
						<input type="text" disabled={this.state.generating} className={this._getClassNameField("email" , this.state.emailValid)} placeholder="Enter your email address" onChange={this._handleEmailChange} ref={this._emailRef}/>
						
					</div>

					<div className="opt-in-options">
					<p>Don't miss out on the latest information regarding our new homes, offers and purchase schemes at this and neighbouring developments.
					</p> 
					<legend >Please tick all the ways you're happy to be contacted</legend> 
				<ul className="">
					<li className="opt-in-option">
						<Checkbox ref={this._checkboxOptInEmailRef} paths={
								[(<path key={HashSource.next()} className="path-icon" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path>)]
							}>
						</Checkbox>
					</li> 
					<li className="opt-in-option">
						<Checkbox ref={this._checkboxOptInPhoneRef} paths={
								[(<path key={HashSource.next()} className="path-icon" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path>)]
							}>
						</Checkbox>
					</li> 
					<li className="opt-in-option">
						<Checkbox ref={this._checkboxOptInTextRef}paths={
								[(<path key={HashSource.next()} className="path-icon" d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"></path>)]
							}>
						</Checkbox>
					</li> 
				</ul>
				<p className="extra-info">(Remember, you can opt out at any time if you change your mind)</p>
				</div>
				<div className="opt-in-warning">
					<div className="icon">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
						<path d="M0 0h24v24H0V0z" fill="none">
						</path>
						<path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z">
						</path>
					</svg>
					</div> 
					<div className="text">In order for us to keep in touch, you need to select one or more of the options above</div>
				</div>
				<div className="agree-tickbox">
					<div className="inner">
						<Checkbox text="" onChange={this._handleCheckboxAgreedToPrivacyNoticeChanged}>
						I have read and agree to the <a target="_blank" onClick={this._handleClickShowPrivacyPolicy}>privacy policy</a></Checkbox>
					</div>
				</div>
				<IconButton className={classNameIconButtonGenerate} text="Send my brochure" disabled={this.state.generating} onClick={this._handleClickGenerate}></IconButton>
				<Spinner spinnerHandles={this._spinnerHandles}/>
				</div>
</div>		)
	}
}